/**
 * Force Measura "Lengd í metrum" +/- to step by 0.1.
 * Theme MAGN quantity-input stays at its own step (usually 1).
 *
 * Measura's stepper uses capture-phase clicks and often ignores
 * purchaseCondition.increment when presets are present, defaulting to 1.
 */
(function () {
  if (window.__measuraLengthStepInit) return;
  window.__measuraLengthStepInit = true;

  const STEP = 0.1;

  const parse = (value) => {
    const n = parseFloat(String(value ?? '').replace(',', '.'));
    return Number.isFinite(n) ? n : NaN;
  };

  const roundStep = (value) => Math.round(value / STEP) * STEP;

  const format = (value) => {
    const rounded = roundStep(value);
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  };

  const isMeasuraLengthInput = (input) => {
    if (!input || input.closest('quantity-input')) return false;
    if (input.name === 'quantity') return false;
    return Boolean(
      input.closest('.measura-input-group') ||
        input.dataset.measurementType === 'length'
    );
  };

  const applyStepAttrs = (root = document) => {
    root.querySelectorAll('.measura-input-group input').forEach((input) => {
      if (!isMeasuraLengthInput(input)) return;
      input.setAttribute('step', String(STEP));
      input.dataset.step = String(STEP);
    });
  };

  const onStepperClick = (event) => {
    const btn = event.target?.closest?.('.measura-stepper-btn');
    if (!btn) return;

    const isPlus = btn.classList.contains('measura-plus');
    const isMinus = btn.classList.contains('measura-minus');
    if (!isPlus && !isMinus) return;

    const group = btn.closest('.measura-input-group');
    const input =
      group?.querySelector('input') ||
      btn.parentElement?.querySelector('input');
    if (!isMeasuraLengthInput(input)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const min = parse(input.min);
    const max = parse(input.max);
    let current = parse(input.value);
    if (!Number.isFinite(current)) current = Number.isFinite(min) ? min : 0;

    let next = roundStep(current + (isPlus ? STEP : -STEP));
    if (Number.isFinite(min)) next = Math.max(min, next);
    if (Number.isFinite(max)) next = Math.min(max, next);

    input.value = format(next);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('click', onStepperClick, true);

  const init = () => applyStepAttrs(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.('.measura-input-group, .measura-block-entry, .atomic-pos-field') ||
          node.querySelector?.('.measura-input-group input')
        ) {
          applyStepAttrs(node);
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
